import LoadingGif from './loading.gif'

export default LoadingGif
